import React from "react";
import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Tab
} from "@mui/material";

const ScopeAccreditation = ({ data, labType }) => {
  if (!data || data.length === 0) return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Card elevation={3}>
        {/* HEADER */}
        <Box
          sx={{
            background:
              "linear-gradient(135deg, #1d4350 0%, #a43931 100%)",
            color: "#fff",
            py: 2,
            textAlign: "center"
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            SCOPE OF ACCREDITATION
          </Typography>
          <Typography variant="caption">(Form 72)</Typography>
        </Box>

        <TableContainer component={Paper} sx={{ maxHeight: 800 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#1d4350",
                    color: "#fff",
                    fontWeight: 700,
                    border: "1px solid #dcdcdc",
                    minWidth: 150
                  }}
                >
                  Assessor
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#1d4350",
                    color: "#fff",
                    fontWeight: 700,
                    border: "1px solid #dcdcdc",
                    minWidth: 120
                  }}
                >
                  Discipline
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#1d4350",
                    color: "#fff",
                    fontWeight: 700,
                    border: "1px solid #dcdcdc",
                    minWidth: 180
                  }}
                >
                  Product / Material Tested
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#1d4350",
                    color: "#fff",
                    fontWeight: 700,
                    border: "1px solid #dcdcdc",
                    minWidth: 180
                  }}
                >
                  Test / Parameter
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#1d4350",
                    color: "#fff",
                    fontWeight: 700,
                    border: "1px solid #dcdcdc",
                    minWidth: 120
                  }}
                >
                  Range / Unit
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#1d4350",
                    color: "#fff",
                    fontWeight: 700,
                    border: "1px solid #dcdcdc",
                    minWidth: 120
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#1d4350",
                    color: "#fff",
                    fontWeight: 700,
                    border: "1px solid #dcdcdc",
                    minWidth: 120
                  }}
                >
                  Assessment Technique Used
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#1d4350",
                    color: "#fff",
                    fontWeight: 700,
                    border: "1px solid #dcdcdc",
                    minWidth: 200
                  }}
                >
                  Remarks
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:nth-of-type(odd)": {
                      backgroundColor: "#f9f9f9"
                    },
                    "&:hover": {
                      backgroundColor: "#f0f7ff"
                    }
                  }}
                >
                  <TableCell
                    sx={{
                      border: "1px solid #dcdcdc",
                      fontSize: "0.875rem"
                    }}
                  >
                    {item.AssessorName || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #dcdcdc",
                      fontSize: "0.875rem"
                    }}
                  >
                    {item.disciplineName || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #dcdcdc",
                      fontSize: "0.875rem"
                    }}
                  >
                    {item.GroupTested || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #dcdcdc",
                      fontSize: "0.875rem"
                    }}
                  >
                    {item.TypeOfTest || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #dcdcdc",
                      fontSize: "0.875rem"
                    }}
                  >
                    {item.unit || "-"}
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #dcdcdc",
                      textAlign: "center"
                    }}
                  >
                    <Chip
                      label={item.status || "N/A"}
                      size="small"
                      sx={{
                        backgroundColor:
                          item.status === "Adequate"
                            ? "#4caf50"
                            : item.status === "Inadequate"
                            ? "#f44336"
                            : "#9e9e9e",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.75rem"
                      }}
                    />
                  </TableCell>
                   <TableCell
                    sx={{
                      border: "1px solid #dcdcdc",
                      textAlign: "center"
                    }}
                  >
                    <Chip
                      label={item.assessmentTechniqueUsed || "N/A"}
                      size="small"
                      sx={{
                        backgroundColor:
                          item.status === "Adequate"
                            ? "#4caf50"
                            : item.status === "Inadequate"
                            ? "#f44336"
                            : "#9e9e9e",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.75rem"
                      }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #dcdcdc",
                      fontSize: "0.875rem"
                    }}
                  >
                    {item.Remarks || "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
};

export default ScopeAccreditation;
